import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '../store/auth';
import { api } from '../lib/api';

export default function ProfileSetupPage() {
  const navigate = useNavigate();
  const { user, loadUser } = useAuthStore();
  const [form, setForm] = useState({
    business_type: user?.business_type || '',
    city: '',
    state_province: '',
    country: 'CA',
    practice_description: '',
  });
  const [saving, setSaving] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setSaving(true);
    try {
      await api.updateProfile(form);
      await loadUser();
      navigate('/onboarding/welcome');
    } catch {
      alert('Failed to save profile');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#F5F0E8] flex items-center justify-center p-8">
      <div className="bg-white rounded-xl shadow-lg p-8 max-w-md w-full">
        <h1 className="text-2xl font-bold text-[#2C3E3D] mb-6">Complete Your Profile</h1>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-[#3D5A5F] mb-1">Business Type</label>
            <input
              type="text"
              value={form.business_type}
              onChange={e => setForm({...form, business_type: e.target.value})}
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#C4754C] focus:border-transparent"
              placeholder="e.g. Dental Practice"
              required
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-[#3D5A5F] mb-1">City</label>
            <input
              type="text"
              value={form.city}
              onChange={e => setForm({...form, city: e.target.value})}
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#C4754C] focus:border-transparent"
              required
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-[#3D5A5F] mb-1">State/Province</label>
            <input
              type="text"
              value={form.state_province}
              onChange={e => setForm({...form, state_province: e.target.value})}
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#C4754C] focus:border-transparent"
              required
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-[#3D5A5F] mb-1">Country</label>
            <select
              value={form.country}
              onChange={e => setForm({...form, country: e.target.value})}
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#C4754C] focus:border-transparent"
            >
              <option value="CA">Canada</option>
              <option value="US">United States</option>
            </select>
          </div>
          <div>
            <label className="block text-sm font-medium text-[#3D5A5F] mb-1">About Your Practice <span className="font-normal text-gray-400">(optional)</span></label>
            <textarea
              value={form.practice_description}
              onChange={e => setForm({...form, practice_description: e.target.value})}
              rows={4}
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#C4754C] focus:border-transparent resize-none"
              placeholder="Describe your practice's unique approach, specialty, or focus areas. This helps generate content specific to your practice type..."
            />
            <p className="mt-1 text-xs text-gray-400">The more detail you provide, the better your AI-generated content will be.</p>
          </div>
          <button
            type="submit"
            disabled={saving}
            className="w-full py-3 bg-[#C4754C] text-white rounded-lg font-semibold hover:bg-[#a8603d] transition-colors disabled:opacity-50"
          >
            {saving ? 'Saving...' : 'Continue'}
          </button>
        </form>
      </div>
    </div>
  );
}
